import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import RestaurantCategories from '@/components/RestaurantCategories';
import StoresGrid from '@/components/RestaurantsGrid';
import LumzaLogo from '@/components/LumzaLogo';
import FloatingActionButton from '@/components/FloatingActionButton';
import WhatsAppSupport from '@/components/WhatsAppSupport';
import { Button } from '@/components/ui/button';
import { MapPin, Phone, Mail, Instagram, Facebook, Twitter } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { useCart } from '@/contexts/CartContext';
import { useNavigate } from 'react-router-dom';
const Index = () => {
  const {
    t
  } = useLanguage();
  const {
    getCartCount
  } = useCart();
  const navigate = useNavigate();
  return <div className="min-h-screen bg-background">
      <Header />
      
      <main>
        <HeroSection />
        <StoresGrid />
      </main>

      {/* WhatsApp Floating Button - Draggable */}
      

      {/* Mobile Floating Action Button */}
      <FloatingActionButton cartItems={getCartCount()} onCartClick={() => navigate('/checkout')} />

      {/* Footer */}
      <footer className="bg-dark-surface border-t border-border/40 py-6 sm:py-8 md:py-12 lg:py-16">
        <div className="container mx-auto px-3 sm:px-4 md:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6 md:gap-8">
            {/* Brand */}
            <div className="space-y-2 sm:space-y-3 md:space-y-4 col-span-1 sm:col-span-2 lg:col-span-1">
              <Link to="/">
                <LumzaLogo size="md" />
              </Link>
              <p className="text-muted-foreground text-xs sm:text-sm leading-relaxed">
                {t('footer.tagline')}
              </p>
              <div className="flex space-x-2 sm:space-x-3 md:space-x-4">
                <Button size="sm" variant="ghost" className="p-2 hover:bg-primary/10 touch-target" aria-label="Follow us on Instagram">
                  <Instagram className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
                </Button>
                <Button size="sm" variant="ghost" className="p-2 hover:bg-primary/10 touch-target" aria-label="Follow us on Facebook">
                  <Facebook className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
                </Button>
                <Button size="sm" variant="ghost" className="p-2 hover:bg-primary/10 touch-target" aria-label="Follow us on Twitter">
                  <Twitter className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
                </Button>
              </div>
            </div>

            {/* Quick Links */}
            <div className="space-y-2 sm:space-y-3 md:space-y-4">
              <h4 className="font-semibold text-sm sm:text-base text-foreground">{t('footer.quickLinks')}</h4>
              <nav className="space-y-1.5 sm:space-y-2 md:space-y-3 text-xs sm:text-sm">
                <Link to="/about" className="block text-muted-foreground hover:text-primary transition-colors py-0.5 sm:py-1 touch-target">
                  About LUMZA
                </Link>
                <Link to="/install" className="block text-muted-foreground hover:text-primary transition-colors py-0.5 sm:py-1 touch-target">
                  Install App
                </Link>
                <a href="#" className="block text-muted-foreground hover:text-primary transition-colors py-0.5 sm:py-1 touch-target">
                  {t('footer.browseRestaurants')}
                </a>
                <Link to="/vendor" className="block text-muted-foreground hover:text-primary transition-colors py-0.5 sm:py-1 touch-target">
                  {t('footer.becomePartner')}
                </Link>
                <Link to="/driver" className="block text-muted-foreground hover:text-primary transition-colors py-0.5 sm:py-1 touch-target">
                  {t('footer.driverSignUp')}
                </Link>
                <Link to="/help" className="block text-muted-foreground hover:text-primary transition-colors py-0.5 sm:py-1 touch-target">
                  {t('footer.helpCenter')}
                </Link>
                <Link to="/legal" className="block text-muted-foreground hover:text-primary transition-colors py-0.5 sm:py-1 touch-target">
                  Legal Hub
                </Link>
              </nav>
            </div>

            {/* Languages */}
            <div className="space-y-2 sm:space-y-3 md:space-y-4">
              <h4 className="font-semibold text-sm sm:text-base text-foreground">{t('footer.languages')}</h4>
              <div className="grid grid-cols-2 gap-1 sm:gap-1.5 md:gap-2 text-xs sm:text-sm">
                <button className="text-left text-muted-foreground hover:text-primary transition-colors p-1.5 sm:p-2 rounded-lg hover:bg-primary/10 touch-target">
                  🇬🇧 English
                </button>
                <button className="text-left text-muted-foreground hover:text-primary transition-colors p-1.5 sm:p-2 rounded-lg hover:bg-primary/10 touch-target">
                  🇿🇦 Zulu
                </button>
                <button className="text-left text-muted-foreground hover:text-primary transition-colors p-1.5 sm:p-2 rounded-lg hover:bg-primary/10 touch-target">
                  🇿🇦 Xhosa
                </button>
                <button className="text-left text-muted-foreground hover:text-primary transition-colors p-1.5 sm:p-2 rounded-lg hover:bg-primary/10 touch-target">
                  🇨🇳 中文
                </button>
              </div>
            </div>

            {/* Contact */}
            <div className="space-y-2 sm:space-y-3 md:space-y-4">
              <h4 className="font-semibold text-sm sm:text-base text-foreground">{t('footer.contact')}</h4>
              <div className="space-y-1.5 sm:space-y-2 md:space-y-3 text-xs sm:text-sm">
                <div className="flex items-start space-x-2 text-muted-foreground">
                  <MapPin className="h-3.5 w-3.5 sm:h-4 sm:w-4 mt-0.5 flex-shrink-0" />
                  <span className="leading-relaxed">Sandton, South Africa</span>
                </div>
                <div className="flex items-start space-x-2 text-muted-foreground">
                  <Phone className="h-3.5 w-3.5 sm:h-4 sm:w-4 mt-0.5 flex-shrink-0" />
                  <span className="leading-relaxed">+27 62 581 9719
                </span>
                </div>
                <div className="flex items-start space-x-2 text-muted-foreground">
                  <Mail className="h-3.5 w-3.5 sm:h-4 sm:w-4 mt-0.5 flex-shrink-0" />
                  <span className="leading-relaxed">hello@lumzadelivery.com</span>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-6 sm:mt-8 md:mt-10 lg:mt-12 pt-4 sm:pt-6 md:pt-8 border-t border-border/40 flex flex-col md:flex-row justify-between items-center gap-2 sm:gap-3 md:gap-4">
            <p className="text-muted-foreground text-[10px] sm:text-xs md:text-sm text-center md:text-left">
              {t('footer.copyright')}
            </p>
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 md:gap-4 text-[10px] sm:text-xs md:text-sm text-muted-foreground text-center">
              <Link to="/legal" className="hover:text-primary transition-colors py-0.5 sm:py-1 touch-target">Legal Hub</Link>
              <Link to="/privacy-policy" className="hover:text-primary transition-colors py-0.5 sm:py-1 touch-target">Privacy</Link>
              <Link to="/terms-of-service" className="hover:text-primary transition-colors py-0.5 sm:py-1 touch-target">Terms</Link>
              
            </div>
          </div>
        </div>
      </footer>
    </div>;
};
export default Index;